var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SocialAuthBtn',{staticClass:"facebook-btn",attrs:{"id":"facebook-login-btn","img":_vm.logo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithFacebook'),"color":"#3b63be","tiny":_vm.tiny},on:{"click":_vm.fLogIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }